import { Fancybox } from "@fancyapps/ui";
import Cookies from 'js-cookie'

const COOKIE_NAME = 'PromoPopupFancyboxClosed'
const EL_SELECTOR = '#js-PromoPopupFancybox'
const EL = document.querySelector(EL_SELECTOR)

if(EL){
  var COOKIE_EXPIRES_DAYS = parseInt(EL.getAttribute('data-expires'))
}

class PromoPopupFancybox {
  constructor() {
    this.init()

    if(!Cookies.get(COOKIE_NAME) && EL){
      this.show()
    }
  }

  init = () => {
    if(!EL){
      return
    }

    const cta = EL.querySelector('.popup-promo__button .btn')

    if(cta){
      cta.addEventListener('click', () => {
        this.setCloseCookie()
      })
    }
  }

  show = () => {
    Fancybox.show(
      [
        {
          src: EL,
          type: "inline"
        },
      ],
      {
        mainClass: "fancybox--promo",
        dragToClose: false,
        showClass: "fancybox-fadeIn",
        on: {
          'destroy': () => {
            this.setCloseCookie()
          }
        }
      }
    );
  }

  setCloseCookie = () => {
    Cookies.set(COOKIE_NAME, 'true', { expires: COOKIE_EXPIRES_DAYS })
  }
}

new PromoPopupFancybox();
